export enum COMMISSION_STATUS {
  'UNCLAIMED' = 0,
  'CLAIMED' = 1
};
